import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import categories from 'EventTracking/consts/categories';
import eventTypes from 'EventTracking/consts/eventTypes';
import eventSubTypes from 'EventTracking/consts/eventSubTypes';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { getEventPropertiesForResourceLogging } from 'Helpers/logging';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { metaOverrideSet } from './metaOverrideSet';

const Layout = ({ btnText, beforeCompletion }) => <MetaControlField beforeCompletion={beforeCompletion} attr="completed" btnText={btnText} />;
Layout.propTypes = {
  btnText: PropTypes.string.isRequired,
  beforeCompletion: PropTypes.func.isRequired,
};

export const CompleteActionItemBanner = ({ resource, btnText, beforeCompletion }) => {
  const { setPageContentCollection } = usePageContentContext();
  const { setModalCollection } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const handlePageCompletionSummaryRelationship = async (rel) => {
    // we want to load this into a modal
    setModalCollection(await rel.link('related').get());
  };

  const handleMissingPageCompletionSummaryRelationship = async () => {
    // if missing, we'll submit the resource and load the result into a page
    const result = await resource.submit();
    setPageContentCollection(result);
  };

  const onChange = async () => {
    const eventProperties = getEventPropertiesForResourceLogging(resource);
    logStandardizedEvent(categories.foundations, eventTypes.click, eventSubTypes.bannerCTA, {
      eventProperties,
    });

    try {
      await resource.withRelationship(
        fr.relationships.pageCompletionSummary.name,
        async (rel) => {
          await handlePageCompletionSummaryRelationship(rel);
        },
        async () => {
          await handleMissingPageCompletionSummaryRelationship();
        },
      );
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  return (<MetaResourceRenderer
    metaOverrideSet={metaOverrideSet}
    onChange={onChange}
    resource={resource}
    layout={Layout}
    LayoutProps={{ btnText, beforeCompletion }}
  />);
};
CompleteActionItemBanner.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  btnText: PropTypes.string,
  beforeCompletion: PropTypes.func,
};
CompleteActionItemBanner.defaultProps = {
  btnText: "I'm done",
  beforeCompletion: () => {},
};
